import Alias from './../build/contracts/Alias.json'

const drizzleOptions = {
  web3: {
    block: false,
    fallback: {
      type: 'ws',
      url: 'ws://127.0.0.1:8545'
    }
  },
  contracts: [
    Alias
  ],
  events: {
  },
  polls: {
    accounts: 1500
  }
}

export default drizzleOptions


// WEBPACK FOOTER //
// ./src/drizzleOptions.js